// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"239":"1fc3abfb","732":"23e6b714","977":"87f7eec3"}[chunkId] + ".chunk.js");